import { create } from 'zustand'
import { persist } from 'zustand/middleware'

interface MockModeState {
  enabled: boolean
  ready: boolean
  enable: () => Promise<void>
  disable: () => Promise<void>
  toggle: () => Promise<void>
}

const STORAGE_KEY = 'city-sense.mockMode'

const startWorker = async () => {
  const { worker } = await import('@/mocks/browser')
  await worker.start({
    onUnhandledRequest: 'bypass',
    serviceWorker: { url: '/mockServiceWorker.js' },
    quiet: true,
  })
}

const stopWorker = async () => {
  const { worker } = await import('@/mocks/browser')
  worker.stop()
}

export const useMockMode = create<MockModeState>()(
  persist(
    (set, get) => ({
      enabled: false,
      ready: false,
      enable: async () => {
        if (get().enabled && get().ready) return
        await startWorker()
        set({ enabled: true, ready: true })
      },
      disable: async () => {
        await stopWorker()
        set({ enabled: false, ready: false })
      },
      toggle: async () => {
        if (get().enabled) {
          await get().disable()
        } else {
          await get().enable()
        }
      },
    }),
    {
      name: STORAGE_KEY,
      partialize: state => ({ enabled: state.enabled }),
    }
  )
)

// Boot the worker on page load when previously enabled — must run in browser only.
export const bootMockModeIfEnabled = async () => {
  if (typeof window === 'undefined') return
  if (useMockMode.getState().enabled) {
    try {
      await startWorker()
      useMockMode.setState({ ready: true })
    } catch (err) {
      console.error('[mockMode] failed to start worker', err)
      useMockMode.setState({ enabled: false, ready: false })
    }
  }
}
